import React from 'react';
import { Radio, ConfigProvider, Space } from 'antd';

import classNames from 'classnames';

import commonStyles from '../../style/components/common.module.scss';
import { createPrimaryTheme } from '../../theme/antd-theme';

interface RadioOption {
  value: string | number | boolean;
  label: string;
  disabled?: boolean;
}

interface RadioGroupProps {
  label?: string;
  options: RadioOption[];
  value?: string | number | boolean;
  onChange: (value: any) => void;
  direction?: 'horizontal' | 'vertical';
  className?: string;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
  required?: boolean;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  options,
  value,
  onChange,
  direction = 'vertical',
  className = '',
  disabled = false,
  error = false,
  errorMessage,
  required = false,
}) => {
  const handleChange = (e: any) => {
    if (!disabled) {
      onChange?.(String(e.target.value));
    }
  };

  return (
    <ConfigProvider theme={createPrimaryTheme()}>
      <div className={classNames(commonStyles.container, className)}>
        {label && (
          <label className={commonStyles.label}>
            {label} {required && <span style={{ color: 'var(--color-success)' }}>*</span>}
          </label>
        )}

        <Radio.Group
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className={classNames({
            [commonStyles.error]: error,
            [commonStyles.disabled]: disabled,
          })}
        >
          <Space
            direction={direction === 'horizontal' ? 'horizontal' : 'vertical'}
            size="middle"
            style={{ width: '100%' }}
          >
            {options.map((option) => (
              <Radio
                key={String(option.value)}
                value={option.value}
                disabled={disabled || option.disabled}
              >
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>

        {error && errorMessage && <span className={commonStyles.errorMessage}>{errorMessage}</span>}
      </div>
    </ConfigProvider>
  );
};

export default RadioGroup;

